import { http } from "@/api/index";

/**
 * @summary Obtém todos os sinais e seus limites customizados da turbina requisitada.
 * @param monitoringElementId Id do elemento de monitoramento do ativo.
 * @returns Retorna um JSON com todos os sinais e seus limites costumizados da turbina.
 */
const GetTrendLimitsData = function(monitoringElementId)
{
	return http.get(`/WindSignalLimits/asset/${monitoringElementId}/TrendLimits`);
};

/**
 * @summary Requisição para a criação de um novo alerta de limites de sinais.
 * @param parameters - Objeto contendo dados do sinal customizado.
 */
const CreateTrendLimitsData = function(parameters)
{
	return http.post("/WindSignalLimits/TrendLimits", parameters);
};

/**
 * @summary Solicita o status do protocolo de um conjunto de unidades geradoras.
 * @param {object} parameters - Ids das turbinas.
 */

const UpdateTrendsLimitsData = function(parameters)
{
	return http.patch(`/WindSignalLimits/TrendLimits/${parameters.signalMonitoringElementId}`,
		parameters,
		{ headers: { "Content-Type": "application/json" }, });
};

/**
 * @summary Solicita o status do protocolo de um conjunto de unidades geradoras.
 * @param {object} parameters - Ids das turbinas.
 */
const DeleteTrendLimitsData = function(parameters)
{
	return http.delete(`/WindSignalLimits/asset/${parameters.assetMonitoringElementId}/TrendLimits/
	${parameters.trendSignalSettingId}/Signal/
	${parameters.trendSignalMonitoringElementId}`);
};

/**
 * @summary Obtém todos os emails mais comuns registrados para notificações.
 * @param monitoringElementId Id do elemento de monitoramento do ativo.
 * @returns Retorna um JSON com todos os emails mais comuns registrados para notificações.
 */
const GetNotificationEmailsData = function(monitoringElementId)
{
	return http.get(`/Notification/asset/${monitoringElementId}/emails`);
};

export default {
	GetTrendLimitsData,
	CreateTrendLimitsData,
	UpdateTrendsLimitsData,
	DeleteTrendLimitsData,
	GetNotificationEmailsData
};